<template>
  <div class="home-box">
    <div class="home-bg" id="indexMap">
      <el-amap
        vid="indexDemo"
        :center="center"
        :zoom="zoom"
        :amap-manager="amapManager"
        :events="mapEvents"
        class="index-demo"
      >
        <el-amap-marker
          v-for="(marker, index) in markers"
          :key="index"
          :position="[marker.longitude, marker.latitude]"
          :icon="
            require('../../assets/home_images/home_point' + marker.ste + '.png')
          "
          :offset="[-18, -20]"
          :events="{ click: () => markerClick(marker) }"
          :vid="index"
          :title="marker.title"
        >
          <!-- :icon="require('../../assets/home_images/home_point.png')" -->
        </el-amap-marker>
        <el-amap-info-window
          isCustom="true"
          :position="currentWindow.position"
          :visible="currentWindow.visible"
          :events="{ close: () => closeWin() }"
          closeWhenClickMap="true"
        >
          <div class="item_map">
            <div class="close-window" @click="closeWin()">
              <i class="el-icon-close"></i>
            </div>
            <h3 class="info-title" :title="lampInfo.name">
              {{ lampInfo.name }}
            </h3>
            <div class="info-content">
              <div v-html="getGasValue(lampInfo.sb)"></div>
            </div>
            <div class="info-controls">
              <button
                class="btn-lamp-control"
                data-text="路灯控制"
                @click="$router.push('/light/lightList')"
              ></button>
              <button
                v-if="lampInfo.camera_list.length > 0"
                class="btn-video-preview"
                data-text="摄像头"
                @click="videoPreview(lampInfo.lamp_id)"
              ></button>
            </div>
          </div>
        </el-amap-info-window>
      </el-amap>
    </div>
    <div class="head">
      <div class="head-bg">
        <div class="head-l"></div>
        <div class="head-c"><h1>{{$store.state.user.title}}</h1></div>
        <div class="head-r"></div>
      </div>
    </div>
    <div class="go-system" @click="$router.push('/gis')">
      <img src="@/assets/home_images/go_system.png" />
    </div>
    <div class="left-top"><img src="@/assets/home_images/left_top.png" /></div>
    <div class="right-top">
      <img src="@/assets/home_images/right_top.png" />
    </div>
    <div class="home-left">
      <div class="home_pad">
        <div class="main-left-top"><box1 :itemData="resData.lamp"></box1></div>
        <div class="main-left-cen">
          <box2 :itemData="resData.camera" :accessToken="accessToken"></box2>
        </div>
        <div class="main-left-bot"><box3 :itemData="resData.env"></box3></div>
      </div>
    </div>
    <div class="home-right">
      <div class="home_pad">
        <div class="main-right-cen"><box4 :itemData="resData.ip"></box4></div>
        <div class="main-right-cen">
          <box5 :itemData="resData.manhole"></box5>
        </div>
        <div class="main-right-cen">
          <box6 :itemData="resData.one_key"></box6>
        </div>
        <div class="main-right-bot">
          <box7 :itemData="resData.alarm"></box7>
        </div>
      </div>
    </div>

    <!-- 查看监控 -->
    <div
      class="box_control_bg"
      v-if="videoData.dialogVisible"
      @click="closeVideo"
    ></div>
    <div class="box_control" v-if="videoData.dialogVisible">
      <div class="box_head">
        <span class="box_title">查看路灯监控</span>
        <div class="box_close" @click="closeVideo">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="box_body">
        <video-mini-control
          ref="video_con"
          :deviceSerial="videoData.ysyNumber"
          :accessToken="accessToken"
        ></video-mini-control>
      </div>
    </div>
  </div>
</template>
<script>
import homeApi from "@/api/home/index";
import lightListApi from "@/api/light/lightList";
import box1 from "@/components/home/box1.vue";
import box2 from "@/components/home/box2.vue";
import box3 from "@/components/home/box3.vue";
import box4 from "@/components/home/box4.vue";
import box5 from "@/components/home/box5.vue";
import box6 from "@/components/home/box6.vue";
import box7 from "@/components/home/box7.vue";
import videoMiniControl from "@/components/video/VideoMiniControl";
import store from "@/store";
import { AMapManager } from "vue-amap";
import VueAMap from "vue-amap";
let amapManager = new VueAMap.AMapManager();
export default {
  components: {
    box1,
    box2,
    box3,
    box4,
    box5,
    box6,
    box7,
    videoMiniControl,
  },
  data() {
    return {
      resData: {},
      boxd: {
        id: 1,
        value: 2,
      },
      amapManager,
      mapEvents: {
        init(o) {
          o.setMapStyle("amap://styles/3bada0cafd920690320e9f2dd6d08568"); //自定义的高德地图的样式，我选的是马卡龙
        },
      },
      zoom: 14,
      center: store.state.user.account.center,
      currentWindow: {
        position: store.state.user.account.center,
        visible: false,
      },
      markers: [],
      lampInfo: {
        name: "",
        lamp_id: "",
        stg_id: "",
        stg_name: "",
        light: "",
        ms: "",
        sb: [],
        camera_list: [],
      },
      videoData: {
        ysyNumber: "",
        dialogVisible: false,
      },
      accessToken: "",
      ws: {},
    };
  },
  methods: {
    init: function () {
      //地图初始化
      map = new AMap.Map("indexMap", {
        resizeEnable: true,
      });
    },
    getData() {
      //获得首页数据
      homeApi.homeData().then((res) => {
        if (res.data.code === 1000) {
          this.resData = res.data.data;
        }
      });
    },

    getLampList() {
      //获得地图标记
      lightListApi
        .lightList({
          page: 1,
          pageSize: 500,
        })
        .then((res) => {
          if (res.data.code === 1000) {
            this.markers = res.data.data.list;
            this.videoGetAccessToken();
          }
        });
    },

    getGasValue(items) {
      let gas_data = [
        "北风",
        "东北风",
        "东风",
        "东南风",
        "南风",
        "西南风",
        "西风",
        "西北风",
      ];
      let itemValue = "";
      for (let i in items) {
        if (items[i].sb_tye == 8) {
          itemValue +=
            items[i].name + "：" + gas_data[items[i].value] + "<br/>";
        } else {
          itemValue += items[i].name + "：" + items[i].value + "<br/>";
        }
      }
      return itemValue;
    },
    markerClick(marker) {
      this.lampInfo = marker;
      this.currentWindow.position = [marker.longitude, marker.latitude];
      this.currentWindow.visible = true;
      setTimeout(function () {
        this.center = [marker.longitude, marker.latitude];
      }, 200);
    },
    closeWin() {
      this.currentWindow.visible = false;
      this.videoData.dialogVisible = false;
    },
    videoPreview(canid) {
      // 打开视频
      lightListApi.lightInfo(canid).then((res) => {
        if (res.data.code === 1000) {
          this.videoData.dialogVisible = true;
          this.videoData.ysyNumber = res.data.data.camera_list[0];
        }
      });
    },
    closeVideo() {
      // 关闭视频
      this.videoData.title = "";
      this.videoData.ysyNumber = "";
      this.videoData.dialogVisible = false;
    },
    videoGetAccessToken() {
      lightListApi.getAccessToken().then((res) => {
        this.accessToken = res.data.accessToken;
      });
    },
    wbInit() {
      let wsPath = "wss://light.taiott.com/wss";
      this.ws = new WebSocket(wsPath);
      //监听是否连接成功
      this.ws.onopen = () => {
        console.log("ws连接状态：" + this.ws.readyState);
        this.ws.send("连接成功"); //连接成功则发送一个数据
        this.ws.send('home.data:3');
      };

      //接听服务器发回的信息并处理展示
      this.ws.onmessage = (res) => {
        console.log("接收到来自服务器的消息：", res.data)
      };

      //监听连接关闭事件
      this.ws.onclose = () => {
        //监听整个过程中websocket的状态
        console.log("ws连接状态：" + this.ws.readyState);
      };

      //监听并处理error事件
      this.ws.onerror = function (error) {
        console.log(error);
      };
    },
  },
  mounted() {
    this.getLampList();
    this.getData();
    // this.$nextTick(() => {
    //   // 禁用右键
    //   document.oncontextmenu = new Function("event.returnValue=false");
    //   // 禁用选择
    //   document.onselectstart = new Function("event.returnValue=false");
    // });

    // this.wbInit();
  },
  destroyed() {
    this.ws.close(); //完成通信后关闭WebSocket连接
  },
};
</script>
<style lang='less'>
.home-box {
  position: relative;
  width: 100%;
  height: 100%;
  background: #191936;
  .home-bg {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    overflow: hidden;
    background: #191936;
    // img {
    //   width: 100%;
    //   height: 100%;
    // }
  }
  .head {
    position: absolute;
    width: 50%;
    height: 122px;
    left: 25%;
    top: 0;
    z-index: 2;
    display: flex;
    justify-content: center;
    background: url("../../assets/home_images/head_bg.png") center top no-repeat;
    .head-bg {
      height: 74px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .head-l {
      width: 74px;
      height: 74px;
      background: url("../../assets/home_images/head_l.png") no-repeat;
    }
    .head-c {
      width: auto;
      height: 74px;
      background: url("../../assets/home_images/head_c.png") 0 0 repeat-x;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 20px;
      h1 {
        font-size: 32px;
        color: #fff;
        font-weight: normal;
      }
    }
    .head-r {
      width: 74px;
      height: 74px;
      background: url("../../assets/home_images/head_r.png") no-repeat;
    }
  }
  .go-system {
    position: absolute;
    width: 150px;
    right: 35px;
    top: 22px;
    z-index: 999;
    cursor: pointer;
    text-align: right;
    img {
      width: auto;
      height: 26px;
    }
  }
  .home-left {
    position: absolute;
    width: 32%;
    height: 100%;
    left: 0;
    top: 0;
    background: linear-gradient(
      to right,
      rgba(13, 19, 33, 1) 0,
      rgba(13, 19, 33, 0.75) 75%,
      transparent 100%
    );
    z-index: 9;
    .home_pad {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding-top: 80px;
      padding-left: 30px;
      position: relative;
      overflow: hidden;
      .main-left-top {
        width: 75%;
        padding: 15px 0;
        height: 36%;
        box-sizing: border-box;
        overflow: hidden;
      }
      .main-left-cen {
        width: 75%;
        padding: 15px 0;
        height: 36%;
        box-sizing: border-box;
        overflow: hidden;
      }
      .main-left-bot {
        padding: 15px 0;
        height: 28%;
        box-sizing: border-box;
      }
    }
  }
  .home-right {
    position: absolute;
    width: 32%;
    height: 100%;
    right: 0;
    top: 0;
    background: linear-gradient(
      to left,
      rgba(13, 19, 33, 1) 0,
      rgba(13, 19, 33, 0.8) 65%,
      transparent 100%
    );
    z-index: 9;
    .home_pad {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding-top: 80px;
      padding-right: 30px;
      position: relative;
      overflow-y: hidden;
      background: url("../../assets/home_images/right_bottom.png") right bottom
        no-repeat;
      .main-right-cen {
        padding: 15px 0;
        height: 23.33%;
        width: 75%;
        box-sizing: border-box;
        float: right;
      }
      .main-right-bot {
        padding: 15px 0;
        width: 100%;
        height: 30%;
        box-sizing: border-box;
        float: right;
      }
    }
  }
  .left-top,
  .right-top {
    position: absolute;
    width: 19.94%;
    left: 0;
    top: 0;
    z-index: 10;
    img {
      width: 100%;
      height: auto;
    }
  }
  .right-top {
    width: 23.489%;
    left: auto;
    right: 0;
  }

  .index-demo {
    width: 100%;
    height: 100%;
  }

  .amap-logo {
    display: none !important;
    opacity: 0 !important;
  }
  .amap-layers {
    background: #191936 !important;
  }

  .item_map {
    background-image: url("../../assets/home_images/item_map.png");
    background-position: 0 0;
    background-size: 100% 100%;
    padding: 20px;
    border-radius: 20px;
    border: 2px solid #ff7bac;
    position: relative;
    min-width: 200px;
    box-sizing: border-box;
    color: #fff;
    .close-window {
      width: 26px;
      height: 26px;
      border-radius: 26px;
      cursor: pointer;
      background: #2e3192;
      display: flex;
      justify-content: center; /* 水平居中 */
      align-items: center; /* 垂直居中 */
      position: absolute;
      top: 10px;
      right: 10px;
      color: #fff;
      i {
        color: #fff;
        font-size: 18px;
      }
    }
    .close-window:hover {
      background: #373bac;
    }
    h3.info-title {
      margin: 0 0 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 20px;
    }
    .info-content {
      margin: 5px 0;
      overflow: hidden;
    }
    .info-content span {
      width: 150px;
      float: left;
    }
    .info-controls {
      overflow-x: auto;
      overflow-y: hidden;
      margin-top: 10px;
      outline: none;
    }
    .info-controls button {
      border: 1px solid #fff;
      border-radius: 50%;
      background-size: 26px;
      background-position: center;
      background-repeat: no-repeat;
      background-color: #282c5e;
      position: relative;
      width: 50px;
      height: 50px;
      line-height: 1.2em;
      margin: 0 15px 25px 0;
      box-sizing: border-box;
      cursor: pointer;
      float: left;
      outline: none;
      color: #fff;
    }
    .info-controls button:after {
      content: attr(data-text);
      display: inline-block;
      font-size: 12px;
      position: absolute;
      top: 55px;
      left: 0;
      right: 0;
      text-align: center;
    }
    .info-controls button.btn-lamp-control {
      background-image: url(../../assets/svg/lamp-control2.svg);
    }
    .info-controls button.btn-video-preview {
      background-image: url(../../assets/svg/video-preview2.svg);
    }
  }
  .item_map:after {
    position: absolute;
    content: "";
    z-index: -1;
    bottom: -8px;
    left: 50%;
    margin-left: -8px;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid #ff7bac;
  }
}
</style>